import { call, put, takeLatest } from 'redux-saga/effects';

import { TripSecurityTable } from 'modules/security/global/interfaces';
import { Trip, TripService } from '../../../../../entities/Trip';
import { getTripsError, getTripsSuccess } from './actions';
import { GET_DIRECTOR_TRIPS_REQUEST, GET_DIRECTOR_UNLOADING_TRIPS_REQUEST } from './constants';

function* createEventSaga(isLoadingTrips: boolean) {
  try {
    const trips: Trip[] = yield call(isLoadingTrips ? TripService.getTrips : TripService.getUnloadingTrips);
    const tripsId8 = trips.filter((t) => t.statusId === 8);
    // const tripsId6 = trips.filter((t) => t.statusId === 6);

    const tripsIdRest = trips.filter((t) => t.statusId !== 8 && t.statusId !== 1);

    tripsIdRest.sort((prev: any, next: any) => prev.statusId - next.statusId);

    const tripsFiltered = [...tripsId8, ...tripsIdRest];

    const formattedTrips: TripSecurityTable[] = yield call(TripService.formatTripsForSecurityTable, tripsFiltered);

    yield put(getTripsSuccess(formattedTrips));
  } catch (error: any) {
    yield put(getTripsError(error));
  }
}

export function* tripsTabSagaWatcher() {
  yield takeLatest(GET_DIRECTOR_TRIPS_REQUEST, createEventSaga, true);
}

export function* unloadingTripsTabSagaWatcher() {
  yield takeLatest(GET_DIRECTOR_UNLOADING_TRIPS_REQUEST, createEventSaga, false);
}
